const { trackMetric } = require('../collector');
const {
  SESSION_ID,
  MLDATA_SESSION_ID,
} = require('../../constants/metrics');
const { getCookie, setCookie } = require('../utils/cookie');
const getUUID = require('../utils/uuid');

const maxAge = 1000 * 60 * 30; // would expire after 30 minutes

const monitor = () => {
  const cookie = getCookie(MLDATA_SESSION_ID);

  if (!cookie) {
    const uuid = getUUID();

    setCookie(MLDATA_SESSION_ID, uuid, { 'max-age': maxAge });

    trackMetric(SESSION_ID, uuid);

    return;
  }

  trackMetric(SESSION_ID, cookie);
};

module.exports = monitor;
